
export function validate(record) {
    const errors = [];

    if (!record.name || record.name.trim() === "") {
        errors.push({ field: 'name', message: 'O nome do perfil é obrigatório!' });
    }

    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}